import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { ShipmentCreditClaimsComponent } from './shipment-credit-claims.component'

@NgModule({
  declarations: [ShipmentCreditClaimsComponent],
  imports: [CommonModule, RouterModule, UrlModule, SharedModule, MaterialModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ShipmentCreditClaimComponent: {
          component: ShipmentCreditClaimsComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class ShipmentCreditClaimsModule {}
